import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, RouterLink, ActivatedRoute } from "@angular/router";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { Observable, Subject } from "rxjs";
import { RegexPatterns } from "./../../../shared/regex/regex-patterns";
import { Profile } from "./../../shared/models/profile";
import moment from "moment";

import { UserService } from "./../../../shared/services/user.service";
import { AppSettingsService } from "./../../../shared/services/app-settings.service";
import { ViewStateService } from "./../../../shared/services/view-state.service";
import { CommonApiService } from "./../../../shared/services/api/common-api.service";
import { PractitionerService } from "./../../shared/services/practitioner.service";
import { NotificationsService } from "./../../../shared/services/notifications.service";
import { filter, takeUntil } from "rxjs/operators";

@Component({
  selector: "app-edit",
  templateUrl: "./edit.component.html",
  styleUrls: ["./edit.component.css"],
})
export class EditComponent implements OnInit, OnDestroy {
  profileForm: UntypedFormGroup;
  profile: Profile;
  countries: any;
  badAddress: boolean = false;
  formLevelErrors: String[] = [];
  badZipMessage = false;
  emailOptOut = false;
  emailOptOutCredExp = false;
  emailOptOutAnnual = false;
  emailOptOutCMPAssessment = false;
  emailOptOutMarket = false;
  emailOptOutResearch = false;
  smscmpAssessmentsOptIn = false;
  smsCredentialExpirationOptIn = false;
  validFormCheck = true;
  private dateInputFormat = this.appSettings.IsCompatibilityMode
    ? "MM/DD/YYYY"
    : "YYYY-MM-DD";
  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    private viewState: ViewStateService,
    private practitionerService: PractitionerService,
    private router: Router,
    private commonApiService: CommonApiService,
    private notification: NotificationsService,
    public appSettings: AppSettingsService
  ) {}

  ngOnInit() {
    this.viewState.startLoading();
    this.profile = new Profile();
    this.profile.personId = this.userService.CurrentUser.personId;
    this.buildForm();
    this.getCountries();
    this.getProfileDetails();
  }

  onSubmit(updatedFormValues: any) {
    this.viewState.startLoading();
    //2020.09.21 New for new opt out structure uncomment when ready
    // if (this.isEmailOptionChanges(this.profileForm.value))
    // {
    //    if (!this.confirmEmailOptOutChanges()) {
    //     this.notification.error("Notification", "Changes not saved.")
    //     this.viewState.stopLoading();
    //     return;
    //    }
    // }
    //
    this.formValues = updatedFormValues;
    this.validateForm();
    this.updateProfile();
  }
  get selectedCountry() {
    return this.profileForm.get("countryId").value;
  }
  get isUs() {
    return this.selectedCountry == 1;
  }
  cancel(event: Event) {
    event.preventDefault();

    this.profileForm.reset();
    this.router.navigate(["/"]);
  }

  private getCountries() {
    this.commonApiService
      .getCountries()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.countries = res;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  private getProfileDetails() {
    if (this.profile.personId) {
      this.practitionerService
        .getProfile(this.profile.personId.toString())
        .pipe(takeUntil(this.destroy$))
        .subscribe((details) => {
          this.profile = details;

          if (this.profile.birthday) {
            this.profile.birthday = moment(this.profile.birthday).format(
              this.dateInputFormat
            );
          }

          this.determineIfBadAddress(details);
          this.profileForm.patchValue(details);
          this.mapStingToBooleanValues(this.profileForm.value);
          this.setOriginalOptOuts(this.profileForm.value);
          this.setOptOut();
          this.viewState.stopLoading();
        });
    }
  }

  allowCmpOptInOrOut() {
    return this.profile.allowCmpOptInOrOut;
  }

  determineIfBadAddress(profile: any) {
    if (profile.badAddress) this.badAddress = true;
  }

  isEmailOptionChanges(values: any) {
    let changed = false;
    if (
      values.emailOptOut != this.emailOptOut ||
      values.emailOptOutAnnual != this.emailOptOutAnnual ||
      values.emailOptOutCMPAssessment != this.emailOptOutCMPAssessment ||
      values.emailOptOutCredExp != this.emailOptOutCredExp ||
      values.emailOptOutMarket != this.emailOptOutMarket ||
      values.emailOptOutResearch != this.emailOptOutResearch ||
      values.smscmpAssessmentsOptIn != this.smscmpAssessmentsOptIn ||
      values.smsCredentialExpirationOptIn != this.smsCredentialExpirationOptIn
    )
      changed = true;
    return changed;
  }

  mapBooleanToStingValues(values: any) {
    //   //smscmpAssessmentsOptIn is actually out
    //   //if (values.smscmpAssessmentsOptIn) this.profileForm.value.smscmpAssessmentsOptIn = "N";
    //   //else this.profileForm.value.smscmpAssessmentsOptIn = "Y";

    //   //if (values.smsCredentialExpirationOptIn) this.profileForm.value.smsCredentialExpirationOptIn = "N";
    //   //else this.profileForm.value.smsCredentialExpirationOptIn = "Y";

    //   if (values.emailOptOut) this.profileForm.value.emailOptOut = true;
    //   else this.profileForm.value.emailOptOut = false;

    //   if (values.emailOptOutCredExp) this.profileForm.value.emailOptOutCredExp = true;
    //   else this.profileForm.value.emailOptOutCredExp = false;

    //   if (values.emailOptOutAnnual) this.profileForm.value.emailOptOutAnnual = true;
    //   else this.profileForm.value.emailOptOutAnnual = false;

    //   if (values.emailOptOutCMPAssessment) this.profileForm.value.emailOptOutCMPAssessment = true;
    //   else this.profileForm.value.emailOptOutCMPAssessment = false;

    //   if (values.emailOptOutMarket) this.profileForm.value.emailOptOutMarket = true;
    //   else this.profileForm.value.emailOptOutMarket = false;

    //   if (values.emailOptOutResearch) this.profileForm.value.emailOptOutResearch = true;
    //   else this.profileForm.value.emailOptOutResearch = false;

    //   if (values.cmpOptOut) this.profileForm.value.cmpOptIn = false;
    //   else this.profileForm.value.emailOptIn = true

    if (values.directoryOptOut) this.profileForm.value.directoryStatus = "O";
    else this.profileForm.value.directoryStatus = "N";

    //   if (this.profile.reviewProfile)
    //      this.profileForm.value.profileReviewed = new Date()
  }

  mapStingToBooleanValues(values: any) {
    if (values.directoryStatus && values.directoryStatus == "O")
      this.profileForm.value.directoryOptOut = true;
    else this.profileForm.value.directoryOptOut = false;
    this.profileForm.value.smscmpAssessmentsOptIn =
      !this.profileForm.value.smscmpAssessmentsOptIn;
    this.profileForm.value.smsCredentialExpirationOptIn =
      !this.profileForm.value.smsCredentialExpirationOptIn;
    this.profileForm.patchValue({
      directoryOptOut: this.profileForm.value.directoryOptOut,
      smscmpAssessmentsOptIn: this.profileForm.value.smscmpAssessmentsOptIn,
      smsCredentialExpirationOptIn:
        this.profileForm.value.smsCredentialExpirationOptIn,
    });
  }
  setOriginalOptOuts(values: any) {
    this.emailOptOut = values.emailOptOut;
    this.emailOptOutCredExp = values.emailOptOutCredExp;
    this.emailOptOutAnnual = values.emailOptOutAnnual;
    this.emailOptOutCMPAssessment = values.emailOptOutCMPAssessment;
    this.emailOptOutMarket = values.emailOptOutMarket;
    this.emailOptOutResearch = values.emailOptOutResearch;
    this.smscmpAssessmentsOptIn = values.smscmpAssessmentsOptIn;
    this.smsCredentialExpirationOptIn = values.smsCredentialExpirationOptIn;
  }

  private validateForm() {
    for (const control in this.profileForm.controls) {
      this.profileForm.controls[control].updateValueAndValidity();
    }

    let hasErrors = false;
    for (const field in this.formErrors) {
      this.formErrors[field] = "";
      const control = this.profileForm.get(field);
      if (control && control.invalid) {
        hasErrors = true;
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + " ";
        }
      }
    }
    if (hasErrors) {
      this.validFormCheck = false;
      this.viewState.stopLoading();
    } else {
      this.validFormCheck = true;
    }
  }

  private buildForm(): void {
    this.profileForm = this.formBuilder.group({
      email: [
        this.formValues.email,
        [Validators.required, Validators.maxLength(100), Validators.email],
      ],
      birthday: [this.formValues.birthday, Validators.required],
      gender: [this.formValues.gender, Validators.required],
      countryId: [this.formValues.countryId, Validators.required],
      line1: [
        this.formValues.line1,
        [
          Validators.required,
          Validators.maxLength(35),
          Validators.pattern(RegexPatterns.alphaNumericSpecial),
        ],
      ],
      line2: [
        this.formValues.line2,
        [
          Validators.maxLength(35),
          Validators.pattern(RegexPatterns.alphaNumericSpecial),
        ],
      ],
      zip: [
        this.formValues.zip,
        [
          Validators.required,
          Validators.maxLength(10),
          // Validators.pattern(RegexPatterns.integersOnly) not for foreign zips
        ],
      ],
      city: [
        this.formValues.city,
        [
          Validators.required,
          Validators.maxLength(35),
          Validators.pattern(RegexPatterns.lettersOnly),
        ],
      ],
      stateProvince: [
        this.formValues.stateProvince,
        [Validators.required, Validators.maxLength(50)],
      ],
      homePhone: [
        this.formValues.homePhone,
        [
          Validators.maxLength(50),
          Validators.pattern(RegexPatterns.integersOnly),
        ],
      ],
      cellPhone: [
        this.formValues.cellPhone,
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(RegexPatterns.integersOnly),
        ],
      ],
      emailOptOut: [this.formValues.emailOptOut],
      emailOptOutCredExp: [this.formValues.emailOptOutCredExp],
      emailOptOutAnnual: [this.formValues.emailOptOutAnnual],
      emailOptOutCMPAssessment: [this.formValues.emailOptOutCMPAssessment],
      emailOptOutMarket: [this.formValues.emailOptOutMarket],
      emailOptOutResearch: [this.formValues.emailOptOutResearch],
      smscmpAssessmentsOptIn: [this.formValues.smscmpAssessmentsOptIn],
      smsCredentialExpirationOptIn: [
        this.formValues.smsCredentialExpirationOptIn,
      ],
      cmpOptIn: [this.formValues.cmpOptIn],
      cmpOptOut: [this.formValues.cmpOptOut],
      directoryOptOut: [this.formValues.directoryOptOut],
      personId: [this.profile.personId],
      directoryStatus: [this.formValues.directoryStatus],
      profileReviewed: [this.formValues.profileReviewed],
      aarcNumber: [
        this.formValues.aarcNumber,
        [Validators.pattern(RegexPatterns.integersOnly)],
      ],
      paperlessAnnualInvoiceOptIn: [
        this.formValues.paperlessAnnualInvoiceOptIn,
      ],
      smsAnnualInvoiceOptIn: [this.formValues.smsAnnualInvoiceOptIn],
    });
  }

  private updateProfile() {
    if (this.profileForm.valid) {
      this.mapBooleanToStingValues(this.profileForm.value);
      this.profileForm.value.smscmpAssessmentsOptIn =
        !this.profileForm.value.smscmpAssessmentsOptIn;
      this.profileForm.value.smsCredentialExpirationOptIn =
        !this.profileForm.value.smsCredentialExpirationOptIn;

      this.practitionerService
        .updateProfile(this.profile.personId.toString(), this.profileForm.value)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (resp) => {
            this.viewState.stopLoading();
            this.notification.success(
              "Success",
              "The profile has been updated."
            );
            this.router.navigate(["/"]);
          },
          (errors) => {
            this.notification.error(
              "Failed",
              "The profile has not been updated."
            );
            this.profileForm.value.smscmpAssessmentsOptIn =
              !this.profileForm.value.smscmpAssessmentsOptIn;
            this.profileForm.value.smsCredentialExpirationOptIn =
              !this.profileForm.value.smsCredentialExpirationOptIn;
            this.mapServerErrorsToForm(errors.error);
            this.viewState.stopLoading();
          }
        );
    } else {
      this.viewState.stopLoading();
    }
  }

  private mapServerErrorsToForm(errorObj: any) {
    let errors = errorObj;
    errors.map((error) => {
      this.formErrors[error.fieldName] = "";
      const control = this.profileForm.get(error.fieldName);
      this.formErrors[error.fieldName] += error.message + " ";
      if (!control) {
        this.formLevelErrors.push(error.message);
      }
    });
    this.viewState.stopLoading();
  }

  private formValues = {
    gender: "",
    birthday: "",
    email: "",
    countryId: "",
    line1: "",
    line2: "",
    zip: "",
    city: "",
    stateProvince: "",
    homePhone: "",
    cellPhone: "",
    smscmpAssessmentsOptIn: "",
    smsCredentialExpirationOptIn: "",
    emailOptOut: "",
    emailOptOutCredExp: "",
    emailOptOutCMPAssessment: "",
    emailOptOutAnnual: "",
    emailOptOutMarket: "",
    emailOptOutResearch: "",
    cmpOptIn: "",
    cmpOptOut: "",
    personId: "",
    directoryOptOut: "",
    directoryStatus: "",
    profileReviewed: "",
    aarcNumber: "",
    paperlessAnnualInvoiceOptIn: "",
    smsAnnualInvoiceOptIn: "",
  };

  formErrors = {
    gender: "",
    birthday: "",
    email: "",
    countryId: "",
    line1: "",
    line2: "",
    zip: "",
    city: "",
    stateProvince: "",
    homePhone: "",
    cellPhone: "",
    smscmpAssessmentsOptIn: "",
    smsCredentialExpirationOptIn: "",
    emailOptOut: "",
    cmpOptIn: "",
    cmpOptOut: "",
    directoryOptOut: "",
    directoryStatus: "",
    aarcNumber: "",
  };

  validationMessages = {
    email: {
      required: "Email is required.",
      maxlength: "Email must be max 100 characters.",
      email: "Email must be in the correct format.",
    },
    birthday: {
      required: "Date of birth is required.",
    },
    gender: {
      required: "Gender is required.",
    },
    countryId: {
      required: "Country is required.",
    },
    line1: {
      required: "Address is required.",
      maxlength: "Address must be max 35 characters.",
      pattern: "Address must be letters & numbers.",
    },
    line2: {
      maxlength: "Address must be max 35 characters.",
      pattern: "Address must be letters & numbers.",
    },
    zip: {
      required: "Zip / Postal Code is required.",
      maxlength: "Zip / Postal Code must be max 10 characters.",
      pattern: "Zip / Postal Code must be numbers only.",
    },
    city: {
      required: "City is required.",
      maxlength: "City must be max 35 characters.",
      pattern: "City must be letters only.",
    },
    stateProvince: {
      required: "State is required.",
      maxlength: "State must be max 50 characters.",
    },
    homePhone: {
      maxlength: "Home Phone must be max 50 characters.",
      pattern: "Home Phone must be numbers only.",
    },
    cellPhone: {
      required: "Cell Phone is required.",
      maxlength: "Cell Phone must be max 50 characters.",
      pattern: "Cell Phone must be numbers only.",
    },
    aarcNumber: {
      pattern: "Must be numeric",
    },
  };
  performZipCodeLookup() {
    this.badZipMessage = false;
    if (this.profileForm.value.countryId === 1) {
      const zip = this.profileForm.value.zip
        ? this.profileForm.value.zip.split("-")
        : "";
      if (!zip) return;

      this.commonApiService
        .lookupStateAndCityByZipCode(zip[0])
        .pipe(
          takeUntil(this.destroy$),
          filter((res) => res.length !== 0)
        )
        .subscribe(
          (val) => {
            const value = val[0] || "";
            if (!value) return;
            this.setFormValue(value);
          },
          (error) => {
            this.badZipMessage = true;
            console.log(error);
          }
        );
    }
  }

  confirmEmailOptOutChanges() {
    if (
      !window.confirm(
        "By clicking ok you are confirming the changes made to your communications preferences and your intent to start and/or stop receiving notices by text/email."
      )
    )
      return false;
    else return true;
  }

  isOptOut(event) {
    if (event.target.checked) {
      if (
        !window.confirm(
          "I acknowledge that choosing “Ok” confirms my intent to stop receiving Credential Maintenance Program notices by email."
        )
      ) {
        this.profileForm.patchValue({
          emailOptOut: false,
        });
      }
    }
  }

  private setFormValue(lookUpValues) {
    this.profileForm.patchValue({
      stateProvince: lookUpValues.stateCode,
      city: lookUpValues.city,
    });
  }

  private setOptOut() {
    if (!this.profileForm.value.cmpOptIn) {
      let control = this.profileForm.get("cmpOptOut");
      control.disable();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
